// Copyright ©️ 2025 eVolve MEP, LLC

import { createContext, type ReactNode } from 'react';

import { WORK_ORDER_LABEL_TYPE_ID } from 'components/Mantine/Labels/constants';
import { useGeneralContext } from 'helpers/useGeneralContext';
import { type LabelsContextType, useLabelsContextValue } from 'hooks/typeCacheHooks/useLabels/useLabelsContextValue';

const WorkOrderLabelsContext = createContext<LabelsContextType | undefined>(undefined);
export const WorkOrderLabelsProvider = ({ children }: { children: ReactNode }) => {
  const contextValue = useLabelsContextValue(WORK_ORDER_LABEL_TYPE_ID);

  return <WorkOrderLabelsContext value={contextValue}>{children}</WorkOrderLabelsContext>;
};

export const useWorkOrderLabels = () => useGeneralContext(WorkOrderLabelsContext, 'WorkOrderLabels');
